import { getPressclippings } from '@/graphql/queries/media/pressclipping';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getPressclippings, { page: 1 }).then(results => {
    const description = store.$i18n.t('in-the-media.description');
    const title = store.$i18n.t('in-the-media.title');
    store.commit('utils/setPagination', results.meta.pagination);
    store.commit('blog/setMedia', results.clippings);
    store.commit('pageContent/setHead', { description, title });
  });
};
